import axiosInstance from '@/apis/axiosInstance';
import { langList } from './index';

const lsLangKey = 'i18nextLng';

/** 将接口或历史数据中的语言码规范到当前产品支持列表，避免已下线语言导致「同步 localStorage ↔ 刷新」死循环 */
export function normalizeToSupportedLang(
  lang: string | undefined | null
): string {
  if (!lang || lang === 'auto') {
    return langList[0].detectedValue;
  }
  const found = langList.find((l) => l.detectedValue === lang);
  return found ? lang : langList[0].detectedValue;
}

/**
 * 获取检测到的用户语言
 *   如果用户有合法的 localStorage 值，则返回对应的语言对象。否则返回默认 en Item
 *   如果没有检测到任何值，则返回默认 en Item
 */
export function getUserLang(sync = false) {
  const lsLangValue = localStorage.getItem(lsLangKey);
  if (lsLangValue) {
    const found = langList.find((lang) => lang.detectedValue === lsLangValue);
    if (found) {
      return found;
    } else {
      if (sync) {
        localStorage.setItem(lsLangKey, langList[0].detectedValue);
      }
      return langList[0];
    }
  } else {
    if (sync) {
      localStorage.setItem(lsLangKey, langList[0].detectedValue);
    }
    return langList[0];
  }
}

/**
 * 处理本地检测语言和 Settings 中的语言冲突
 */
export function handleLangConflict(lang: string, initUserLang: string) {
  const next = normalizeToSupportedLang(lang);
  if (next === initUserLang) {
    return;
  }
  localStorage.setItem(lsLangKey, next);
  console.log(
    '[i18n]: need reload, user.lang=',
    lang,
    ', normalized=',
    next,
    ', while initUserLang=',
    initUserLang
  );
  window.location.reload();
}

/**
 * 处理语言设置切换
 */
export async function handleI18nChange(lang: string) {
  localStorage.setItem(lsLangKey, lang);
  await axiosInstance
    .post('/influencer/info', {
      lang
    })
    .finally(() => {
      window.location.reload();
    });
}
